export const getDeviceType = () => {
  const ua = navigator.userAgent.toLowerCase();

  const isIpadOld = ua.includes('ipad');
  const isIpadNew = ua.includes('macintosh') && 'ontouchend' in document;

  if (isIpadOld || isIpadNew) {
    return 'ipad';
  }

  // Mobile phones
  if (/mobi|iphone|ipod|android.*mobile/.test(ua)) {
    return 'mobile';
  }

  // Tablets (non-iPad)
  if (/android|tablet/.test(ua)) {
    return 'tablet';
  }

  return 'desktop';
};
